import React, { Fragment, useState } from 'react'
import { Tooltip } from 'reactstrap'

const TooltipControlled = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  let placement = props.placement ?? 'bottom';
  return (
        
    <Fragment>
        <span id={props.id} className='battle-card-cons'>{props.text}</span>
        <Tooltip
          placement={placement}
          isOpen={tooltipOpen}
          target={props.id}
          toggle={() => setTooltipOpen(!tooltipOpen)}
        >
          {props.tooltip}
        </Tooltip>
    </Fragment>
  )
}
export default TooltipControlled